// src/components/Footer.js

export default function Footer() {
  return (
    <footer style={styles.footer}>

      {/* ======= TOP SCROLLING TEXT ======= */}
      <div style={styles.scrollContainer}>
        <div style={styles.scrollText}>
          पंचायत समिती बल्लारपूर – अधिकृत वेबसाइट | महाराष्ट्र शासन | विकास हीच प्रगती |
        </div>
      </div>

      {/* ======= GOVERNMENT LOGOS ROW ======= */}
      <div style={styles.logoRow}>

        <a href="https://www.maharashtra.gov.in/" target="_blank" rel="noopener noreferrer">
          <img src="/images/Seal_of_Maharashtra.png" alt="Maharashtra Govt" style={styles.logo} />
        </a>

        <a href="https://rdd.maharashtra.gov.in/" target="_blank" rel="noopener noreferrer">
          <img src="/images/panchayat.png" alt="Panchayat Raj" style={styles.logo} />
        </a>

        <a href="https://pmaymis.gov.in/" target="_blank" rel="noopener noreferrer">
          <img src="/images/pm-awas.jpg" alt="PM Awas Yojana" style={styles.logo} />
        </a>

        <a href="https://swachhbharatmission.gov.in/" target="_blank" rel="noopener noreferrer">
          <img src="/images/swachh.png" alt="Swachh Bharat" style={styles.logo} />
        </a>

        <a href="https://digitalindia.gov.in/" target="_blank" rel="noopener noreferrer">
          <img src="/images/digital-india.png" alt="Digital India" style={styles.logo} />
        </a>

        <a href="https://amritmahotsav.nic.in/" target="_blank" rel="noopener noreferrer">
          <img src="/images/amrit.png" alt="Azadi ka Amrit Mahotsav" style={styles.logo} />
        </a>

      </div>

      <div style={styles.container}>

        {/* ===== Column 1 ===== */}
        <div style={styles.column}>
          <h3 style={styles.heading}>पंचायत समिती बल्लारपूर</h3>
          <p style={styles.text}>
            पंचायत समिती ही ग्रामीण भागातील एक महत्त्वाची स्वराज्य संस्था आहे जी
            विकासकामे, कल्याणकारी योजना व प्रशासन यांचा समन्वय करते.
          </p>
            <p style={styles.text}><b>Phone:</b> 9623210159</p>
          <p style={styles.text}><b>Email: </b> bdopsballarpur@gmail.com</p>
        </div>

        {/* ===== Column 2 ===== */}
        <div style={styles.column}>
          <h3 style={styles.heading}>Useful Links</h3>

          <a href="https://www.maharashtra.gov.in" target="_blank" rel="noopener noreferrer" style={styles.link}>महाराष्ट्र शासन</a>
          <a href="https://www.india.gov.in" target="_blank" rel="noopener noreferrer" style={styles.link}>भारत सरकार</a>
          <a href="https://www.bing.com/search?pglt=43&q=zpchandrapur&cvid=e6f11f8187f74be58aaba41bcf4ae628&gs_lcrp=EgRlZGdlKgYIABBFGDkyBggAEEUYOTIGCAEQABhAMgYIAhAAGEAyBggDEAAYQDIGCAQQABhAMgYIBRAAGEAyBggGEAAYQDIGCAcQABhAMgYICBAAGEDSAQkyNDI1N2owajGoAgiwAgE&FORM=ANNTA1&PC=U531" target="_blank" rel="noopener noreferrer" style={styles.link}>ZP चंद्रपूर</a>
          <a href="https://pmindia.gov.in" target="_blank" rel="noopener noreferrer" style={styles.link}>पंतप्रधान कार्यालय</a>
        </div>

        {/* ===== Column 3 ===== */}
        <div style={styles.column}>
          <h3 style={styles.heading}>Connect With Us</h3>

          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" style={styles.link}>📘 Facebook</a>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" style={styles.link}>🐦 Twitter</a>
          <a href="https://google.com" target="_blank" rel="noopener noreferrer" style={styles.link}>🔍 Google</a>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" style={styles.link}>🔗 LinkedIn</a>
        </div>

      </div>

      <p style={styles.copy}>
        © {new Date().getFullYear()} पंचायत समिती बल्लारपूर. सर्व हक्क राखीव.
      </p>

    </footer>
  );
}

// =====================================================
// INTERNAL CSS
// =====================================================

const styles = {
  footer: {
    backgroundColor: "#0d1b2a",
    color: "#fff",
    paddingTop: "20px",
    paddingBottom: "10px",
    textAlign: "center",
    marginTop: "40px",
  },

  // Scrolling text
  scrollContainer: {
    width: "100%",
    overflow: "hidden",
    whiteSpace: "nowrap",
    borderTop: "1px solid #1b263b",
    borderBottom: "1px solid #1b263b",
    padding: "8px 0",
    marginBottom: "15px",
    background: "#1b263b",
  },

  scrollText: {
    display: "inline-block",
    animation: "scroll-left 14s linear infinite",
    fontSize: "18px",
  },

  // LOGO ROW
  logoRow: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "25px",
    padding: "10px 0 20px 0",
  },

  logo: {
    height: "65px",
    width: "auto",
    transition: "0.3s",
    filter: "drop-shadow(0px 0px 3px #ffffffa8)",
    cursor: "pointer",
  },

  container: {
    display: "flex",
    justifyContent: "space-around",
    flexWrap: "wrap",
    padding: "0 20px",
  },

  column: {
    width: "30%",
    minWidth: "250px",
    marginBottom: "20px",
    textAlign: "left",
  },

  heading: {
    fontSize: "20px",
    marginBottom: "10px",
    borderBottom: "2px solid #415a77",
    paddingBottom: "5px",
  },

  text: {
    fontSize: "16px",
    lineHeight: "1.6",
  },

  link: {
    display: "block",
    color: "#cfd8e4",
    fontSize: "17px",
    margin: "6px 0",
    textDecoration: "none",
    transition: "0.3s",
  },

  copy: {
    marginTop: "20px",
    fontSize: "14px",
    opacity: "0.8",
  },
};

// Inject Keyframes
const styleTag = document.createElement("style");
styleTag.innerHTML = `
@keyframes scroll-left {
  0% { transform: translateX(100%); }
  100% { transform: translateX(-100%); }
}

/* Hover effect for Footer Logos */
img:hover {
  transform: scale(1.13);
  filter: drop-shadow(0px 0px 8px #ffffff);
}
`;
document.head.appendChild(styleTag);
